import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useServiceClosingNotification } from '../hooks/useOperationTime';
import ServiceClosingModal from './ServiceClosingModal';

interface ServiceClosingGuardProps {
  children: React.ReactNode;
}

const ServiceClosingGuard: React.FC<ServiceClosingGuardProps> = ({ children }) => {
  const location = useLocation();
  const {
    shouldShowClosingModal,
    checkClosingStatus,
    dismissClosingModal
  } = useServiceClosingNotification();

  // 페이지 이동 시마다 30분 전 체크 (하루에 한 번만 표시)
  useEffect(() => {
    // 약간의 지연을 두고 체크 (페이지 로딩 완료 후)
    const timer = setTimeout(() => {
      checkClosingStatus();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, checkClosingStatus]);

  return (
    <>
      {children}
      <ServiceClosingModal 
        isOpen={shouldShowClosingModal}
        onClose={dismissClosingModal}
      />
    </>
  );
};

export default ServiceClosingGuard; 